import axios from 'axios';

export default {
    fetchAllWorkstations() {
        return axios.post('/workstation/fetchAll/');
    },
    fetchByCustomView(customView) {
        return axios.post('/workstation/fetchByCustomView/', { customView });
    },
    fetchAllTypesWithWorkstations(sort) {
        return axios.post('/workstation/fetchAllTypesWithWorkstations/', {
            sort,
        });
    },
    fetchAllTypes(sort, onlyShowInProgress) {
        return axios.post('/workstation/fetchAllTypes/', {
            sort,
            onlyShowInProgress,
        });
    },
    fetchById(id) {
        return axios.post('/workstation/fetchById/', { id });
    },
    fetchByKey(key) {
        return axios.post('/workstation/fetchByKey/', { key });
    },
    removeById(id) {
        return axios.post('/workstation/removeById/', { id });
    },
    removeType(id) {
        return axios.post('/workstation/removeTypeById/', { id });
    },
    createWorkstation(payload) {
        return axios.post('/workstation/createWorkstation', payload);
    },
    updateWorkstation(payload) {
        return axios.post('/workstation/updateWorkstation', payload);
    },
    fetchWorkstationsForMenu() {
        return axios.post('/workstation/fetchWorkstationsForMenu/');
    },
    fetchTypeValidationRules() {
        return axios.post('/workstation/fetchTypeValidationRules/');
    },
    fetchTypeById(id, withWorkstations) {
        return axios.post('/workstation/fetchTypeById/', {
            id,
            withWorkstations,
        });
    },
};
